import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lecture-schedule-filltable',
  templateUrl: './lecture-schedule-filltable.component.html',
  styleUrls: ['./lecture-schedule-filltable.component.scss']
})
export class LectureScheduleFilltableComponent implements OnInit {

  slots:any;
  workingDaysData: any = [
    {item_id: 'saturday', item_text: this.translate.instant('SATURDAY')},
    {item_id: 'sunday', item_text: this.translate.instant('SUNDAY')},
    {item_id: 'monday', item_text: this.translate.instant('MONDAY')},
    {item_id: 'tuesday', item_text: this.translate.instant('TUESDAY')},
    {item_id: 'wednesday', item_text: this.translate.instant('WEDNESDAY')},
    {item_id: 'thursday', item_text: this.translate.instant('THURSDAY')},
    {item_id: 'friday', item_text: this.translate.instant('FRIDAY')},
  ];
  currentslotLecId:any;
  constructor(private toastrService: ToastrService, public globals: Globals, private router: Router,
    public translate: TranslateService) { }

  ngOnInit(): void {
       this.slots = [
      {
        id:1,
        day: "tuesday",
        slotID: 1,
        startTime: "8:30:00",
        endTime: "9:30:00",
        subject: "NUrsing G1",
        lecturer: "Mahmoud Reda"
      },
      {
        id:2,
        day: "tuesday",
        slotID: 1,
        startTime: "10:30:00",
        endTime: "11:30:00",
        subject: "NUrsing G2",
        lecturer: "Ali Farag"
      },
    ];
  }
  addSlotSubject(){
    this.slots.push(
      {
        id:3,
        day: "tuesday",
        slotID: 1,
        startTime: "10:30:00",
        endTime: "11:30:00",
        subject: "NUrsingLAb G2",
        lecturer: "Ali Farag 2"
      }
    );
  }

  updateCurrentSlotId(id: number) {
    // this.currentRepeaterIndex = index;
    this.currentslotLecId = id;
  }
  removeSlotLec(){
    this.slots.splice(this.slots.length-1, 1);
  }

}
